module.exports = __webpack_public_path__ + "img/insert_plot.8b25d958.png";